export default (fetch) => {
  return {
    // 公告接口
    async noticeList(params) {
      const {data} = await fetch.get('/arcopen/user/config/notice', {params})
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error('公告列表获取失败')
      }
    }
  }
}
